import React, { useRef, useEffect, useState } from 'react'
import { Tooltip, Button } from 'antd'
import { PushpinOutlined, DeleteOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons'
import BOT_LOGO from '../../../../asserts/icon/icon-logo.svg'
import { ChartIcon } from '../../../../components/icons'
import moment from 'moment'
import Editor from '../../../../components/message/editor'
import BotMessage from './BotMessage'
import BotFeedback from './BotFeedback'
import { BOT_USER_NAME, BOT_USER_ID } from '../../../../utils/constant.js'
import { deduplicateDocuments } from '../../../../utils'

export const Message = ({ item, isThreadsWindow, msg, onClickViewThread, onReplyInThread, firstUnreadRef,
    selectedThread, threads, onClickPinMessage, onDeleteMessage, personId, setEditMessageId, editMessageId,
    onEditMessage, users, selectedMessageId, documents, explanation, userRole, previousMessage
}) => {
    const messageRef = useRef(null)
    const [isHovered, setIsHovered] = useState(false)

    useEffect(() => {
        if (selectedMessageId === msg._id && messageRef.current) {
            messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }, [selectedMessageId])

    const deduplicatedDocuments = deduplicateDocuments(documents)

    return (
        <React.Fragment key={msg._id || msg.ts}>
            {(msg._id === firstUnreadRef.current && !isThreadsWindow) ? (
                <div className='text-red'>------------------- Unread ------------------------</div>
            ) : (<></>)}
            <div
                ref={messageRef}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'relative',
                    backgroundColor: selectedMessageId === msg._id ? '#f4f6f8' : (msg.pinned ? '#FFF8D1' : 'transparent'),
                    borderRadius: '8px',
                    padding: '8px'
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Message Content */}
                <div className='message'>
                    <div className='message-avatar'>
                        {item.sender_person === BOT_USER_NAME ? <img src={BOT_LOGO} alt={'profile'} /> : item.img ? <img src={item.img} alt={'profile'} /> :
                            (<>
                                <img src={`data:image/svg+xml;utf8,
                                    <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'>
                                    <text x='50%' y='50%' font-size='48' text-anchor='middle' 
                                    dominant-baseline='middle' font-family='Gilroy'>
                                    ${item.sender_person ? item.sender_person.charAt(0) : ''} 
                                    </text>
                                    </svg>`} alt={'profile'} />
                            </>)}
                    </div>
                    <div className='message-text'>
                        <div>
                            <span className='message-user-name'>{item.sender_person === BOT_USER_NAME ? 'Apeiron AI' : item.sender_person}</span>
                            <span className='message-date'>
                                {moment(item.created_at).format('MMM DD, YYYY')} at{' '}
                                {moment(item.created_at).format('h:mm A')}
                            </span>
                            {msg.pinned ? (
                                <PushpinOutlined style={{ fontSize: '12px', cursor: 'pointer', marginLeft: '5px' }} />
                            ) : (<></>)}
                        </div>
                        {editMessageId === msg._id ? (
                            <Editor
                                id={msg._id}
                                value={item.editMsg}
                                loading={false}
                                clientId={personId}
                                close={() => setEditMessageId(null)}
                                onSubmitCallback={(messages) => onEditMessage(msg, messages)}
                                isChatPage={true}
                                users={users}
                            />
                        ) : (
                                <>
                                    {deduplicatedDocuments.length > 0 ? (
                                        <>
                                            <BotMessage documents={deduplicatedDocuments} explanation={explanation} />
                                            {item.sender_person === BOT_USER_NAME && (
                                                <BotFeedback
                                                    messageId={msg._id}
                                                    botResponse={item.text}
                                                    query={previousMessage || 'General query'}
                                                    role={userRole}
                                                    personId={personId}
                                                    roomId={msg.rid}
                                                    feedbacks={msg.feedbacks || []}
                                                    messageFeedback={msg.feedback}
                                                />
                                            )}
                                        </>
                                    ) : (
                                        <div dangerouslySetInnerHTML={{ __html: item.text }} />
                                    )}

                                </>
                        )}
                        {
                            isThreadsWindow ? (<></>) : (<>
                                {msg['tcount'] && msg['tcount'] > 0 ? (
                                    <div>
                                        <span>replies {(msg['tcount'] ? msg['tcount'] : 0) + ' '}</span>
                                        <Button
                                            size='small'
                                            onClick={() => onClickViewThread(msg)}
                                        >View Thread</Button>
                                    </div>
                                ) : (<></>)}
                            </>)
                        }
                    </div>
                </div>

                {/* Message Status */}
                {/* {msg.u.username.split('_')[1] !== String(personId) ? (<></>) : (<div className="message-status">
                    <span>
                        <CheckOutlined style={{ color: msg.unread ? 'gray' : 'blue' }} />
                    </span>
                </div>)} */}

                {/* Hover Actions */}
                {(isHovered && msg._id !== editMessageId) && (
                    <div style={{
                        display: 'flex', gap: '8px', position: 'absolute', right: '8px', top: '0',
                        transform: 'translateY(-50%)',
                        background: 'white'
                    }}>
                        {msg.pinned ? (<></>) : (<Tooltip title="Pin Message">
                            <PushpinOutlined style={{ fontSize: '16px', cursor: 'pointer' }}
                                onClick={() => onClickPinMessage(msg)} />
                        </Tooltip>)}
                        {msg.u.username !== BOT_USER_ID && msg.u.username.split('_')[1] === String(personId) && (
                            <>
                                <Tooltip title="Edit Message">
                                    <EditOutlined style={{ fontSize: '16px', cursor: 'pointer' }}
                                        onClick={() => setEditMessageId(msg._id)} />
                                </Tooltip>
                                {msg.tcount ? (<></>) : (<Tooltip title="Delete Message">
                                    <DeleteOutlined
                                        style={{ fontSize: '16px', cursor: 'pointer', color: 'red' }}
                                        onClick={() => onDeleteMessage(msg)}
                                    />
                                </Tooltip>)}
                            </>
                        )}
                        {msg.u.username !== BOT_USER_ID && !isThreadsWindow && <Tooltip title="Reply in Thread">
                            <ChartIcon onClick={() => onReplyInThread(msg)} />
                        </Tooltip>}
                    </div>
                )}
            </div>
            {isThreadsWindow && msg._id === selectedThread._id ? (
                <>
                    <div className='divider'>{threads.length} replies</div>
                </>
            ) : (<></>)}
        </React.Fragment>
    )
}
